<template>
  <div class="page">
    <div class="page-content">
      <div v-if="isStandardScreen" class="page-img-container">
        <img class="page-img" src="@assets/svgs/bg-guide-add-device.svg" alt="" />
      </div>
      <div class="page-content-container">
        <span class="cancel-btn" @click="emit('cancel')">{{ $t('owork_base.cancel') }}</span>

        <div class="page-content-text">
          <div class="page-content-model">{{ $t('owork_base.add_device') }}</div>
          <div class="page-content-text-describe">
            {{ $t('owork_base.connect_device_tips') }}
          </div>

          <div class="page-tips">{{ $t('owork_base.version_tips', { OSField, OSVersion }) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useSharedScreen } from '@/core/compositions/Screen'
  import { useSharedBrand } from '@/core/compositions/UseBrand'

  const { OSField, OSVersion } = useSharedBrand()
  const { isStandardScreen } = useSharedScreen()

  const emit = defineEmits(['cancel'])
</script>

<style lang="stylus" scoped>
  @import '../styles/devicesModal.styl'
  .page-content-text
    margin-top 148px
    .page-tips
      margin-top 8px
      font-size 14px

  @import '../styles/h5Adaptive/GuidePopperComponent.styl'

  @media screen and (max-width h5_width_threshold )
    .isFileManager
      .page
        .page-content
          .page-content-container
            .page-content-text
              margin-top 56px
              .page-content-text-describe
                margin-top 20px
                color h5_default_color
                font-weight h5_default_font_weight
              .page-tips
                color h5_default_shallow_color
                margin-top 12px
                padding 0 16px
</style>
